import React, { useCallback, useEffect, useState } from "react";
import { ArrowRight, ArrowLeft } from "lucide-react";
export const usePrevNextButtons = (emblaApi) => {
  const [prevBtnDisabled, setPrevBtnDisabled] = useState(true);
  const [nextBtnDisabled, setNextBtnDisabled] = useState(true);

  const onPrevButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollPrev();
  }, [emblaApi]);

  const onNextButtonClick = useCallback(() => {
    if (!emblaApi) return;
    emblaApi.scrollNext();
  }, [emblaApi]);

  const onSelect = useCallback((emblaApi) => {
    setPrevBtnDisabled(!emblaApi.canScrollPrev());
    setNextBtnDisabled(!emblaApi.canScrollNext());
  }, []);

  useEffect(() => {
    if (!emblaApi) return;

    onSelect(emblaApi);
    emblaApi.on("reInit", onSelect).on("select", onSelect);
  }, [emblaApi, onSelect]);

  return {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  };
};

export const PrevButton = (props) => {
  const { navClass, children, ...restProps } = props;

  return (
    <button
      type="button"
      className="w-10 h-10 text-gray-400 hover:text-gray-600 rounded-full flex items-center justify-center border border-gray-200 hover:bg-gray-100 transition disabled:opacity-50 disabled:cursor-not-allowed"
      {...restProps}
    >
      <ArrowLeft
        size={18}
        className={navClass === "carousel-one" ? `text-gray-700` : `text-white`}
      />
      {children}
    </button>
  );
};

export const NextButton = (props) => {
  const { navClass, children, ...restProps } = props;

  return (
    <button
      type="button"
      className="w-10 h-10 text-gray-400 hover:text-gray-600 rounded-full flex items-center justify-center border border-gray-200 hover:bg-gray-100 transition disabled:opacity-50 disabled:cursor-not-allowed"
      {...restProps}
    >
      <ArrowRight
        size={18}
        className={navClass === "carousel-one" ? `text-gray-700` : `text-white`}
      />
      {children}
    </button>
  );
};
